export enum StepperTheme {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum StepperMode {
  HORIZONTAL = 'horizontal',
  RADIAL = 'radial',
}
